import { Pipe, type PipeTransform } from '@angular/core';
import { ensureItemsArray } from '@pct-ts/common';

@Pipe({
  name: 'ensureItemsArray',
})
export class EnsureItemsArrayPipe<T> implements PipeTransform {
  transform(values: T | T[] | null): T[] {
    return ensureItemsArray(values);
  }
}
